// api.js

const axios = require("axios")

/**
 * ==============================
 * FRONTEND AXIOS CLIENT
 * ==============================
 * - The frontend should only call `/api/...`
 * - This hits Gatsby Functions (serverless) first
 * - Never expose the real API base URL or API key here
 */
const API = axios.create({
  baseURL: '/api', // Always points to Gatsby Functions
})

// Response interceptor for nicer error messages
API.interceptors.response.use(
  function (response) {
    return response
  },
  function (error) {
    if (error.response && error.response.data && error.response.data.message) {
      return Promise.reject(error.response.data.message)
    } else {
      return Promise.reject(error)
    }
  }
)

/**
 * ==============================
 * FRONTEND FUNCTIONS (uses API)
 * ==============================
 * - These functions will call Gatsby Functions (`/api/...`)
 * - Gatsby Functions will forward requests securely to the real backend
 */
const functions = {
  async getAccountById(id) {
    let response = await API.get(`v1-proxy/account`, { params: { id } })
    return response.data
  },
  async getSalesforceDataLinks(email) {
    let response = await API.get("v1-proxy/portalLogin", { params: { email } })
    return response.data
  },
  async getServicesFeedback(accountId) {
    let response = await API.get("v1-proxy/servicesFeedback", {
      params: { accountId },
    })
    return response.data
  },
  async getOutreachReport(accountId) {
    let response = await API.get("v1-proxy/outreach", {
      params: { accountId },
    })
    return response.data
  },
  async getOutreachMessages(
    start_date,
    end_date,
    direction,
    bulkMessageId,
    smsKeyword,
    status
  ) {
    let response = await API.get("v1-proxy/messages", {
      params: {
        start_date,
        end_date,
        direction,
        bulkMessageId,
        smsKeyword,
        status,
      },
    })
    return response.data
  },
  async getFavorites(accountId) {
    let response = await API.get("v1-proxy/account/swipes", {
      params: { accountId },
    })
    return response.data
  },
  async getAllVerifiedServiceProviders() {
    let response = await API.get("v1-proxy/accounts")
    return response.data
  },
  async getAllProviders() {
    let response = await API.get("v1-proxy/all-accounts")
    return response.data
  },
}

export default functions

